import { Injectable } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';

@Injectable({
  providedIn: 'root',
})
export class CookiesService {
  cookiesOpen: boolean;

  constructor(public cookiesService: CookieService) {
    this.cookiesOpen = this.cookiesService.check('merlin_cookies');
  }

  cookies: any;
  //cookiesOpen = Boolean(localStorage.getItem('[Merlin] cookies'));
  

  binaryToNumber(bin) {
    return `${parseInt(bin, 2)}`;
  }

  NumberToBinary(num) {
    return num.toString(2);
  }

  getExpirationDate() {
    var now = new Date();
    var time = now.getTime();
    var expireTime = time + 1000 * 36000;
    return now.setTime(expireTime);
  }

  convertPreferencesToBoolean(value) {
    const result = {
      technical: value.technical ? true : false,
      preferences: value.preferences ? true : false,
      analytics: value.analytics ? true : false,
      ads: value.ads ? true : false,
    };
    return result;
  }

  acceptAll() {
    const result = {
      technical: true,
      preferences: false,
      analytics: true,
      ads: true,
    };

    const bin = '1011';

    this.cookiesOpen = true;
    this.cookiesService.set('merlin_cookies', this.binaryToNumber(bin), 365, '/', null, false);
    //localStorage.setItem('[Merlin] cookies', JSON.stringify(result));

    return result;
  }

  rejectAll() {
    const result = {
      technical: true,
      preferences: false,
      analytics: false,
      ads: false,
    };

    const bin = '1000';

    this.cookiesOpen = true;
    //localStorage.setItem('[Merlin] cookies', JSON.stringify(result));
    this.cookiesService.set('merlin_cookies', this.binaryToNumber(bin), 365, '/', null, false);
    return result;
  }

  saveCookiesSettings(settings) {
    const bin = `${settings.technical ? '1' : '0'}${settings.preferences ? '1' : '0'}${settings.analytics ? '1' : '0'}${
      settings.ads ? '1' : '0'
    }`;

    this.cookiesOpen = true;

    //localStorage.setItem('[Merlin] cookies', JSON.stringify(this.convertPreferencesToBoolean(settings)));
    //this.cookiesService.set('merlin_cookies', JSON.stringify(this.convertPreferencesToBoolean(settings)), 365, '/', null, false);
    this.cookiesService.set('merlin_cookies', this.binaryToNumber(bin), 365, '/', null, false);
  }

  closeCookies(accepted) {
    if (accepted === 'accepted') {
      this.acceptAll();
    }

    if (accepted === 'rejected') {
      this.rejectAll();
    }
  }
}
